import React from 'react'
import CheckIcon from 'react-icons/lib/fa/check'
import { Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem, ModalFooter, Button } from 'reactstrap'

class PlanListModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: props.toggle
        };
        this.toggle = this.toggle.bind(this)
    }

    toggle() {
        this.setState({
            modal: false
        });
    }

    render() {
        let { isSeasoned, id, name } = this.props
        return (
            <Modal isOpen={this.state.modal}>
                <ModalHeader>Subscriptions Plan List</ModalHeader>
                <ModalBody>
                    <ListGroupItem>
                        &emsp;
                        <strong>ID:&nbsp;</strong>
                        {id}
                        &ensp;&mdash;
                        <strong>&ensp;Name:&ensp;</strong>
                        {name}
                        &ensp;&mdash;
                        <strong>&ensp;Is_seasoned:&ensp;</strong>
                        {isSeasoned ? 'True' : 'False'}
                    </ListGroupItem>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default PlanListModal



// WEBPACK FOOTER //
// ./src/components/ui/PlanListModal.js